'use client';

import React from 'react';
import { CasinoLogoPlaceholder } from '@/components/ThemedPlaceholders';

type Props = {
  src?: string | null;
  name: string;
  alt: string;
  title?: string;
  className?: string;
};

function getInitials(name: string) {
  return String(name ?? '')
    .trim()
    .split(/\s+/)
    .filter(Boolean)
    .slice(0, 2)
    .map((part) => part.charAt(0).toUpperCase())
    .join('') || 'P';
}

export function ProviderLogoWithFallback({ src, name, alt, title, className = '' }: Props) {
  const [failed, setFailed] = React.useState(false);
  const normalizedSrc = String(src ?? '').trim();

  React.useEffect(() => {
    setFailed(false);
  }, [normalizedSrc]);

  if (!normalizedSrc || failed) {
    return <CasinoLogoPlaceholder initials={getInitials(name)} className={className} />;
  }

  return (
    // eslint-disable-next-line @next/next/no-img-element
    <img
      src={normalizedSrc}
      alt={alt}
      title={title}
      className={className}
      onError={() => setFailed(true)}
    />
  );
}
